import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const WidgetTooltipWrapper = ({ content, children }) => {
  return (
    <Tippy content={content} trigger="mouseenter" placement="left">
      <span style={{ display: "inline-block" }}>{children}</span>
    </Tippy>
  );
};

export default WidgetTooltipWrapper;
